export default __webpack_public_path__ + "static/media/bidifylogo_matic.d86fdc29.png";